import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  Scale,
  ScaleInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredNumber } from "~/utils/validations";

type Values = {
  howGrateful: Scale | undefined;
};

const validationSchema = Yup.object({
  howGrateful: requiredNumber,
});

export const HowGratefulPage: FC = () => {
  const { t } = useTranslation();
  const { howGrateful } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    howGrateful: howGrateful || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.howGratefulPage.question")} />

          <ScaleInput
            autoAdvance
            id="howGrateful"
            scalePath="onboarding.howGratefulPage"
            defaultValue={howGrateful}
          />
        </QuestionContainer>

        <NextButton showButton={!!howGrateful} />
      </FormContainer>
    </QuestionPageContainer>
  );
};
